import { Outlet } from "react-router-dom";

const Layout : React.FC = () => {
    return (
        <main className="notranslate">
            <Outlet />
        </main>
    )
}

export default Layout;